import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import messages from '../../ScheduleForm.messages';

export const PublishScheduleDraftModal = () => (
  <Confirm
    title={<Message message={messages.modals.publishScheduleDraft.title} />}
    cancelNode={<Message message={messages.modals.cancel} />}
    acceptNode={<Message message={messages.modals.submit} />}
    isOpen>
    <Message message={messages.modals.publishScheduleDraft.confirmation} />
  </Confirm>
);
